
import mModal from '../../mModal/index.vue';
import Datepicker from '@vuepic/vue-datepicker';
import './style/main.css';
import moment from 'moment';
import 'moment/locale/ru';

moment.locale('ru');

export default {
    components: {
        mModal,
        Datepicker,
    },
    emits: ['close', 'selectDate'],
    computed: {
        formatDate() {
            const newDate = moment(this.date).unix()
            return moment.unix(newDate).format('ll')
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        save() {
            this.$emit('selectDate', new Date(this.date));
            this.close();
        }
    },
    created: function () {
        this.moment = moment;
    },
    data() {
        return {
            defaultDateText: 'Не выбрано',
            date: null,
        }
    }
}
